"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../../elements/elements/Embedded/constants");
const styleSchema = {};
exports.default = { [constants_1.TYPE]: { style: styleSchema, font: {}, feedback: {} } };
